<template>
  <div class="interviewVideo_main" id="videoContainer">
    <!--此处根据pdf的页数动态生成相应数量的canvas画布-->
    <canvas
      v-for="pageIndex in pdfPages"
      :id="`pdf-canvas-` + pageIndex"
      :key="pageIndex"
      style="display: block"
    ></canvas>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick } from "vue";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import { useRoute } from "vue-router";

let pdfDoc = reactive({}); // 保存加载的pdf文件流
let pdfPages = ref(0); // pdf文件的页数
let pdfUrl = ref(""); //pdf文件的链接
let pdfScale = ref(1.0); // 缩放比例

//获取pdf文档流与pdf文件的页数
const loadFile = async (url) => {
  pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/worker.js';
  const loadingTask = pdfjsLib.getDocument(url);
  loadingTask.promise.then((pdf) => {
    pdfDoc = pdf;
    pdfPages.value = pdf.numPages;
    nextTick(() => {
      renderPage(1);
    });
  });
};

const { width } = window.screen;

//渲染pdf文件
const renderPage = (num) => {
  pdfDoc.getPage(num).then((page) => {
    const canvasId = "pdf-canvas-" + num;
    const canvas = document.getElementById(canvasId);
    const ctx = canvas.getContext("2d");
    const dpr = window.devicePixelRatio || 1;
    const bsr =
      ctx.webkitBackingStorePixelRatio ||
      ctx.mozBackingStorePixelRatio ||
      ctx.msBackingStorePixelRatio ||
      ctx.oBackingStorePixelRatio ||
      ctx.backingStorePixelRatio ||
      1;
    const ratio = dpr / bsr;
    const viewport = page.getViewport({ scale: pdfScale.value });
    canvas.width = viewport.width * ratio;
    canvas.height = viewport.height * ratio;

    const scale = width / viewport.width > 1 ? 1 : width / viewport.width;

    canvas.style.width = viewport.width * scale + "px";
    canvas.style.height = viewport.height * scale + "px";

    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    const renderContext = {
      canvasContext: ctx,
      viewport: viewport,
    };
    page.render(renderContext);
    if (num < pdfPages.value) {
      renderPage(num + 1);
    }
  });
};

const instructions = {
  // starton: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/星豚Starton操作说明书.pdf",
  startonDoc: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/startonDoc.pdf",
  // startonMold: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/星豚Starton操作说明书（开模）.pdf",
  lanwhale: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/3D智能配镜仪使用说明书.pdf",
  // 天鸽英文版
  columbaEV: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Columba.pdf",
  // 蓝鲸英文版
  lanwhaleEV: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Lan whale.pdf",
  // 星豚英文版
  startonEV: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Starton.pdf",
  // 天鹅610英文版
  swan610EV: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Swan 610S.pdf",
  // 天鹅630英文版
  swan630EV: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Swan 630S.pdf",
  // 天鹅730英文版
  swan730EV: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Swan 730S.pdf",
  // 星豚260G英文版
  Starton260G: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Starton260G.pdf",
  // 天鹅630E
  Swan630E:  "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Swan630E.pdf",
  // 天鸽320E
  Vision320E: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Vision320E.pdf",
  // 天猫100G
  Lynx100G: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Lynx100G.pdf",
  // 天龙830E
  Draco830E: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Draco830E.pdf",
  columba310S: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Columba 310S Vision Screener.pdf",
  DarkBoxMK: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Dark Box MK II.pdf",
  Lynx130G: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/Lynx 130G.pdf",
  OptiTureSeries: "https://ask-003-1388908610.cos.ap-guangzhou.myqcloud.com/file/ProductVideo/OptiTure Series.pdf",
};

const titles = {
  starton: "星豚Starton操作说明书",
  startonDoc: "星豚打印系统使用说明书",
  startonMold: "星豚Starton操作说明书",
  lanwhale: "蓝鲸操作说明书",
  columbaEV: "Columba",
  lanwhaleEV: "Lan whale",
  startonEV: "Starton",
  swan610EV: "Swan 610S",
  swan630EV: "Swan 630S",
  swan730EV: "Swan 730S",
  Starton260G: "Starton 260G",
  Swan630E: "Swan 630E",
  Vision320E: "Vision 320E",
  Lynx100G: "Lynx 100G",
  Draco830E: "Draco 830E",
};

const route = useRoute();
const { type } = route.query;

if (type) {
  pdfUrl.value = instructions[type];
  document.title = titles[type];
}

//调用loadFile方法
onMounted(() => {
  loadFile(pdfUrl.value);
});
</script>
<style>
#videoContainer {
  height: 100vh;
  width: 100vw;
  overflow-y: scroll;
}
</style>
